const groupBooking = (() => {
  document.addEventListener("DOMContentLoaded", () => {
    const {innerWidth, location:{origin}} = window
    const isMobile = innerWidth <= 768
    groupBooking.fetchCoreActivities(origin);
    groupBooking.handleGroups();
    groupBooking.handleNewsletter();
    groupBooking.handleSendRequest();
    groupBooking.handlBackToForm(isMobile);
  });
  
  return {
    // utils
    parseCoreActivities: (list) => {
      const newData = {};
      list.forEach(({groupName, id, name}) => {
        if (newData?.[groupName]) {
          newData[groupName] = [...newData[groupName], {id, name, groupName}]
        } else {
          newData[groupName] = [{id, name, groupName}]
        }
      })
      return newData
    },
    // fetchers
    fetchCoreActivities: (url) => {
      const {value: langId} = document.getElementById('langId') ?? '41'
      fetch(`${url}/api/core_activities?langId=${langId}`)
      .then((res) => res.json())
      .then((res) => {
        const options= groupBooking.parseCoreActivities(res)
        const container = document.getElementById('core-activities-dropdown')
        container.innerHTML = groupBooking.renderDropDown({
          options, 
          defaultOption: {id: 'placeholder', name: document.getElementById('trs-select').value}
        })
        groupBooking.handleMultipleChoiceDropDown(options);
      });
    },
    postRequest: (button) => {
      const {value: first_name} = document.getElementById('first-name')
      const {value: last_name} = document.getElementById('last-name')
      const {value: email} = document.getElementById('email')
      const {value: message} = document.getElementById('message-textarea') ?? ''
      const {value: radio} = document.querySelector('input[type=radio]:checked')
      const type = document.querySelector('#type .group-selected')?.dataset?.option ?? ''
      const mailingList = document.getElementById('newsletter')


      const group_size = radio === 'range' ? 
        (document.querySelector('#size .group-selected')?.dataset?.option ?? '') 
        : (document.getElementById('group-customize-input').value ?? '')
      const group_type = type === 'other' ?
        (document.getElementById('type-customize-input').value ?? '') 
        : type


      const activities = document.querySelectorAll('#selected-options .selected-item')
      
      const ca_ids = activities?.length ? [...activities].map(({dataset: {selectedId}}) => Number(selectedId)) : []
    

      const config = {
        method: 'POST',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          first_name,
          last_name,
          email,
          message,
          group_size,
          group_type,
          ca_ids,
          mailing_list: mailingList.classList.contains('checkmark-checked') ?? false,
        })
      }
      fetch(`${window.location.origin}/api/group_requests`, config)
        .then(res => res.json())
        .then((res) => {
          groupBooking.renderSuccess(res?.msg);
          button.disabled = false
        })
        .catch((e) => {
          console.log({e})
          toast.error('Something went wrong. Please try again.', {delay: 5000}, toast.fade);
          button.disabled = false
        })
    },
    // handlers
    handlBackToForm: (isMobile) => {
      const btn = document.getElementById('back-to-cta')
      const scrollHeight = isMobile ? 2300 : 1750
      document.addEventListener('scroll', () => {
        document.documentElement.scrollTop > scrollHeight ? btn.classList.add('anchor-fade-in') : btn.classList.remove('anchor-fade-in')
      })
    },
    handleValidation: ({field, submit}) => {
      const emailValidation = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
      field.addEventListener('blur', () => {
        const {name, value, nextElementSibling} = field
        const isValid = name === 'email' ? 
        emailValidation.test(value.toLowerCase().trim()) :
        value.length > 0
        if (!isValid) {
          field.classList.add('text-input_error')
          nextElementSibling.innerText = document.getElementById(`error-msg-${name}`).value
        }
        const errors = document.querySelectorAll('#contact-us .text-input_error')
        submit.disabled = errors.length > 0
      })

      field.addEventListener('focus', () => {
        field.classList.remove('text-input_error')
        field.nextElementSibling.innerText = ''
      })

    },
    handleSendRequest: () => {
      const submit = document.getElementById('submit-form')
      const form = document.getElementById('contact-us')
      const textInputs = document.querySelectorAll('#contact-us input[type=text]')
      textInputs.forEach((field) => {
        groupBooking.handleValidation({field, submit})
      })


      form.addEventListener('submit', (e) => {
        e.preventDefault()
        groupBooking.postRequest(submit)
        submit.disabled = true
      })

    },
    handleNewsletter: () => {
      const newsLetter = document.getElementById('newsletter')
      newsLetter.addEventListener('click', () => {
        newsLetter.classList.toggle('checkmark-checked')
      })
    },
    handleGroupSelection: ({containerId}) => {
      const groupValues = document.querySelectorAll(`#${containerId} .group`)
      groupValues.forEach((group) => {
        group.addEventListener('click', () => {
          const selectedGroup = [...groupValues].find(({classList}) => classList.contains('group-selected'))
          const input = document.getElementById('type-customize-input')
          if (!selectedGroup) {
            group.classList.add('group-selected')
            if (containerId === 'type' && group.dataset.option === 'other') {
              input.classList.remove('hide')
            }
          } else if (selectedGroup.dataset.option === group.dataset.option) {
            selectedGroup.classList.remove('group-selected')
            if (containerId === 'type' && group.dataset.option === 'other') {
              input.classList.add('hide')
            }
          } else {
            selectedGroup.classList.remove('group-selected')
            group.classList.add('group-selected')
            if (containerId === 'type' && group.dataset.option === 'other') {
              input.classList.remove('hide')
            } else {
              input.classList.add('hide')
            }
          }

        })
      })

    },
    handleGroups: () => {
      const radios = document.querySelectorAll('.radio-container .radio-btn input')
      const groups = document.querySelectorAll('.groups-container')
      radios.forEach((radio) => {
        radio.addEventListener('click', () => {
          groups[radio.value === 'other' ? 1 : 0].classList.remove('hide')
          groups[radio.value === 'range' ? 1 : 0].classList.add('hide')
        })
      })
      groupBooking.handleGroupSelection({containerId: 'size'})
      groupBooking.handleGroupSelection({containerId: 'type'})
    },
    handlePills: ({selectionContainerId, containerId}) => {
      const pills = document.querySelectorAll(`#${selectionContainerId} .selected-item`)
      const defaultOption = document.getElementById('default-option')
      const isMobile = window.innerWidth <= 768
      if (!isMobile) {
        defaultOption.innerText = pills?.length ? '' : document.getElementById('trs-select').value
      }

      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          pill?.remove()
          const option = document.querySelector(`#${containerId} .dropdown-item[data-option-name=${pill.dataset.selectedName}]`);
          const input = option.querySelector('input');
          const checkmark = option.querySelector('.checkmark')
          input.checked = false;
          option.classList.remove('selection-bg')
          checkmark.classList.remove('checkmark-checked')
        })
      })
    },
    handleCheckbox: ({option, input, selectionContainerId}) => {
      const {checked} = input
      const {dataset: {optionId, optionName}} = option
      const selectionContainer = document.getElementById(`${selectionContainerId}`)
      const checkmark = option.querySelector('.checkmark')
      if (checked) {
        option.classList.add('selection-bg')
        checkmark.classList.add('checkmark-checked')
        selectionContainer.insertAdjacentHTML('afterbegin', groupBooking.renderPill({id: optionId, name: optionName}))
      } else {
        option.classList.remove('selection-bg')
        checkmark.classList.remove('checkmark-checked')
        const selection = selectionContainer.querySelector(`.selected-item[data-selected-id='${optionId}']`)
        selection?.remove();
      }
    },
    handleSelection: ({containerId, selectionContainerId}) => {
      const options = document.querySelectorAll(`#${containerId} .dropdown-item`)
      options.forEach((option) => {
        option.addEventListener('click', () => {
          const input = option.querySelector('input')
          input.checked = !input.checked
          groupBooking.handleCheckbox({option, input, selectionContainerId})
          groupBooking.handlePills({selectionContainerId, containerId})
        })
      })
    },
    handleSelectAll: ({selectionContainerId, containerId}) => {
      const selectAll = document.querySelector(`#${containerId} #select-all`)
      selectAll.addEventListener('click', () => {
        const options = document.querySelectorAll(`#${containerId} .dropdown-item`)
        options.forEach((option) => {
          const input = option.querySelector('input')
          if (!input.checked) {
            input.checked = true;
            groupBooking.handleCheckbox({option, input, selectionContainerId})
          }
          groupBooking.handlePills({selectionContainerId, containerId})
        })
      })
    },
    handleClearAll: ({selectionContainerId, containerId}) => {
      const clearAll = document.querySelector(`#${containerId} #clear-all`)
      clearAll.addEventListener('click', () => {
        const options = document.querySelectorAll(`#${containerId} .dropdown-item`)
        options.forEach((option) => {
          const input = option.querySelector('input')
          input.checked = false;
          groupBooking.handleCheckbox({option, input, selectionContainerId})
          groupBooking.handlePills({selectionContainerId: 'modal-selected-options', containerId: 'modal-activities'})
        })
      })

    },
    handleClearSearch: ({clearIcon, searchInput, containerId, isMobile, coreActivities}) => {
      clearIcon.addEventListener('click', () => {
        searchInput.value = '';
        clearIcon.remove();
        groupBooking.handleNoValue({ containerId, isMobile, coreActivities})
      })
    },
    handleNoValue: ({containerId, isMobile, coreActivities}) => {
      document.querySelector(`#${containerId} .options-container`).innerHTML = groupBooking.renderGroupOptions({options: coreActivities, containerId});
      isMobile ? groupBooking.handleMobileInteraction({coreActivities})
      : groupBooking.handleLaptopInteraction({containerId: 'core-dropdown', selectionContainerId: 'selected-options'})
    },
    handleSearch: ({containerId, coreActivities, isMobile}) => {
      const searchInput = document.querySelector(`#${containerId} .core-search`)
      searchInput.addEventListener('keyup', () => {
        const { value } = searchInput;
        const regex = new RegExp(value.toLowerCase());
        if (isMobile) {
          const clearIcon = document.getElementById('clear-search')
          if (value.length > 0) {
            if (!clearIcon) {
              const clearSearch = `
                <div id="clear-search">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#F4F5F4"/>
                    <path d="M15 9L9 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              `
              document.querySelector('.modal-search-container').insertAdjacentHTML('beforeend', clearSearch)
              groupBooking.handleClearSearch({clearIcon: document.getElementById('clear-search'), searchInput, containerId, isMobile, coreActivities})
            }
          } else {
            clearIcon?.remove()
          }
        }
        if (value) {
          const newData = {};
          Object.entries(coreActivities).forEach(([group, activities]) => {
            const matches = activities.filter(({name}) => regex.test(name.toLowerCase()))
            if (matches.length) {
              newData[group] = matches;
            }
          })
          const element = Object.entries(newData)?.length ? groupBooking.renderGroupOptions({options: newData, containerId}) : "<p class='no-results'>No activity found.</p>"
          document.querySelector(`#${containerId} .options-container`).innerHTML = element;
          isMobile ? groupBooking.handleMobileInteraction({coreActivities})
          : groupBooking.handleLaptopInteraction({containerId: 'core-dropdown', selectionContainerId: 'selected-options'})
          
        } else {
          groupBooking.handleNoValue({containerId, isMobile, coreActivities})
        }
      })
    },
    handleMobileInteraction: ({containerId = 'modal-activities', selectionContainerId = 'modal-selected-options'}) => {
      groupBooking.handleSelection({selectionContainerId, containerId})
      groupBooking.handleSelectAll({selectionContainerId, containerId})
      groupBooking.handleClearAll({selectionContainerId, containerId})
    },
    handleCloseModal: () => {
      modals.destroy()
      document.body.style.position = '';
      document.body.style.top = '';
      document.getElementById('type').scrollIntoView()
    },
    handleModalAction: () => {
      const done = document.getElementById('modal-close')
      const container = document.querySelector('.dropdown-container #selected-options')
      done.addEventListener('click', () => {
        const selections = [...document.querySelectorAll('#modal-selected-options .selected-item')].map(
          ({dataset: {selectedName, selectedId}}) => ({name: selectedName, id: selectedId}))
        groupBooking.handleCloseModal()
        const emptySelection = `<span data-option-id="placeholder" id="default-option">
          ${document.getElementById('trs-select').value}
        </span>`
        container.innerHTML = selections.length ? selections.map(groupBooking.renderPill).join('') : emptySelection
      })

      const close = document.querySelector('#modal .close')

      close.addEventListener('click', () => {
        groupBooking.handleCloseModal()
      })

    },
    handleDropdownBehavior: ({arrow, content}) => {
      const rotation = arrow.attributes.getNamedItem("transform")?.value;
      content.classList.toggle("visible");
      arrow.setAttribute(
        "transform",
        !rotation || rotation === "rotate(0)"
        ? "rotate(180)"
        : "rotate(0)"
      );
    },
    handleLaptopInteraction: ({containerId = 'core-dropdown', selectionContainerId = 'selected-options'}) => {
      groupBooking.handleSelection({containerId, selectionContainerId})
      groupBooking.handleSelectAll({containerId, selectionContainerId})
      groupBooking.handleClearAll({containerId, selectionContainerId})
    },
    handleMultipleChoiceDropDown: (coreActivities) => {
      const {innerWidth} = window
      const isMobile = innerWidth <= 768
      
      const target = document.querySelector(
        "#core-activities-dropdown .dropdown-container"
			);
      const arrow = document.querySelector(
        "#core-activities-dropdown #arrow"
      )
      
      const content = document.querySelector(
        "#core-activities-dropdown .dropdown-content"
      )
      
      target.addEventListener('click', () => {
        if (isMobile) {
          document.body.style.position = 'fixed'
          document.body.style.top = `-${window.scrollY}px`
          const selectedActivities = document.querySelectorAll('#core-activities-dropdown #selected-options .selected-item')
          groupBooking.renderModal({coreActivities, selectedActivities})
          groupBooking.handleMobileInteraction({coreActivities})
          groupBooking.handleSearch({containerId: 'modal-activities', coreActivities, isMobile})
          groupBooking.handleModalAction()
        } else {
          groupBooking.handleDropdownBehavior({arrow, content})
        }
      })
      
      if (!isMobile) {
        arrow.addEventListener('click', () => groupBooking.handleDropdownBehavior({arrow, content}))
        groupBooking.handleLaptopInteraction({containerId: 'core-dropdown', selectionContainerId: 'selected-options'})
        groupBooking.handleSearch({containerId: 'core-activities-dropdown', coreActivities})
        window.addEventListener('click', ({target}) => {
          const isVisible = document.getElementById('core-dropdown').classList.contains('visible')
          if (isVisible 
            && !target.matches('.dropdown-content') 
            && !target.matches('.dropdown-container')
            && !target.matches('.checkbox-label')
            && !target.matches('.dropdown-item')
            && !target.matches('.selected-item-text')
            && !target.matches('.activities')
            && !target.matches('svg')
            && !target.matches('path')
            && !target.matches('#arrow')
            && !target.matches('#clear-all')
            && !target.matches('#select-all')
            && !target.matches('#search-input')
            && !target.matches('#default-option')
            && !target.matches('#selected-options')
          ) {
            groupBooking.handleDropdownBehavior({arrow, content})
          }

        })
      }

		},
  // Renders
  renderSuccess: (msg) => {
    const {value:trsSuccessfull} = document.getElementById('form-successfull')
    const {value:trsSuccessfullContent} = document.getElementById('form-successfull-content')
    const {value: trsmailingList} = document.getElementById('successfull-mailing-list')

    const body = `
      <div id="modal-success">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M43.8621 22.1838V24.0111C43.8596 28.2942 42.4727 32.4618 39.9082 35.8923C37.3437 39.3227 33.7389 41.8323 29.6316 43.0467C25.5243 44.2611 21.1344 44.1153 17.1167 42.631C13.0991 41.1467 9.66884 38.4034 7.33764 34.8103C5.00644 31.2171 3.89918 26.9667 4.18099 22.6929C4.46281 18.4191 6.1186 14.3509 8.90142 11.095C11.6842 7.83908 15.445 5.56996 19.6228 4.62604C23.8006 3.68213 28.1716 4.11398 32.0839 5.8572" stroke="#2A3735" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M43.862 8.27588L24.1272 28.1379L18.2068 22.1853" stroke="#2A3735" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h2 class="group-subtitle">
          ${trsSuccessfull}
        </h2>
        <div class="modal-text-container">
          <span class="modal-text modal-text_center_small">
            ${trsSuccessfullContent}
          </span>
            ${msg === 'unverified' ? `<p class="modal-text modal-text_center_small">
              ${trsmailingList}
            </p>` : ''}
        </div>
      </div>
    `
    modals.create('', body, '')
    const close = document.querySelector('#modal button.close')
    close.addEventListener('click', () => {
      modals.destroy()
      window.location.reload()
    })
  },
  renderActions: () => {
    const {value: selectAll} = document.getElementById('trs-select-all')
    const {value: clearAll} = document.getElementById('trs-clear-all')
    return `
      <div class="actions-container">
        <span id='select-all'>${selectAll}</span>
        <span id='clear-all'>${clearAll}</span>
      </div>
    `
  },
  renderModal: ({coreActivities, selectedActivities}) => {
    const {value: done} = document.getElementById('done')
    const {value: selectActivities} = document.getElementById('trs-select')
    const text = 'What are you interested in?'
    const body = `
      <div id="modal-activities">
        <div class="modal-interest-container">
          <div id='modal-selected-options'>
          ${selectedActivities.length ? 
            [...selectedActivities].map(({dataset: {selectedId, selectedName}}) => groupBooking.renderPill({id: selectedId, name: selectedName})).join('')
            : ''}
          </div>
          <div class="modal-search-container">
            <input type="text" class="core-search" placeholder='${selectActivities}'>
          </div>
        </div>
        ${groupBooking.renderActions()}
        <div class="options-container">
          ${groupBooking.renderGroupOptions({options: coreActivities, selectedActivities})}
        </div>
      </div>
    `
    const footer = `
      <div class="modal-footer">
        <button id="modal-close">${done}</button>
      </div>
    `
    modals.create(
      text,
      body,
      footer,
      '',
      false,
      '',
      '',
      'group-booking-modal'
    );
  },
  renderPill: ({ name, id }) => `
    <div class='selected-item' data-selected-name="${name}" data-selected-id=${id}>
      <p class='selected-item-text'>${name}</p>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#0BB696"/>
        <path d="M15 9L9 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  `,
  renderOption: ({id, name, containerId = 'modal-activities', selectedActivities = []}) => {
    const selection = document.querySelectorAll(`#${containerId} .selected-item`)
    const selectedElements = selectedActivities.length ? selectedActivities : selection
    const isChecked = Boolean([...selectedElements].find(({dataset:{selectedId}}) => Number(selectedId) === Number(id)))
    return `<div class='dropdown-item' data-option-id='${id}' data-option-name="${name}">
      <input type="checkbox" id=${id} name="${name}" ${isChecked ? 'checked' : ''}/>
      <div class='checkmark ${isChecked ? 'checkmark-checked' : ''}'>
        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 5L5 9L13 1" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <p class="checkbox-label">${name}</p>
    </div>
    `
  },
  renderGroupOptions: ({options, containerId = 'modal-activities', selectedActivities = []}) => {
    const groups = Object.entries(options).map(([group, items]) => {
      return `
      <p class='activities'>${group}</p>
        <div class="activities-container" data-group=${group}>
          ${items.map(({id, name}) => groupBooking.renderOption({id, name, containerId, selectedActivities})).join('')}
        </div>
      `
    })
    return groups.join('');
  },
  renderDefaultOption: ({ id, name }) => `
    <div id='selected-options'>
      <span data-option-id='${id}' id='default-option'>
        ${name}
      </span>
    </div>
  `,
  renderDropDown: ({
    options,
    defaultOption = null,
  }) => {
    const {value} = document.getElementById('trs-search')
    const svg = `
              <svg id='arrow' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9L12 15L18 9" stroke="#474F4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          `;
    return `
            <label class='label-form'>
              <div class='dropdown-container'>
                <div>
                  ${groupBooking.renderDefaultOption({
                    id: defaultOption?.id,
                    name: defaultOption?.name,
                  })}
                </div>
                  ${svg}
                </div>
              </label>
              <div class='dropdown-content' id='core-dropdown'>
              <input id='search-input' class="core-search" type='text' placeholder='${value}'>
              ${groupBooking.renderActions()}
              <div class="options-container">${groupBooking.renderGroupOptions({options})}</div>
            `;
  },
}
})();

export default groupBooking;
